/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DragAndDropGridComponent} from './drag-and-drop-grid.component';
import {DragDropModule} from '@angular/cdk/drag-drop';

@NgModule({
    declarations: [DragAndDropGridComponent],
    imports: [
        CommonModule,
        DragDropModule
    ],
    exports: [DragAndDropGridComponent]
})
export class DragAndDropGridModule {
}
